import styled from "styled-components";

export const CoachStatusAligner = styled.div`
  margin: 5px auto;
  width: 100%;
  max-width: 860px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const CoachStatusContainer = styled.div`
  padding-right: 10px;
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const CoachStatusImg = styled.img`
  width: 40px;
  height: 40px;
`;
export const CoachStatusText = styled.p`
  margin: 0 20px 0;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  text-align: center;
`;
export const CoachStatusButton = styled.button`
  width: 60px;
  height: 30px;
  display: flex;
  align-items: center;
  background-color: ${({ disabled, isCoachStatus }) => (disabled ? "#999" : isCoachStatus ? "#39b54a" : "#ccc")};
  border: none;
  outline: none;
  border-radius: 50px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
  position: relative;
`;
export const CoachStatusButtonBall = styled.div`
  width: 40%;
  height: 80%;
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
  left: ${({ isCoachStatus }) => (isCoachStatus ? "53.333333333333336%" : "6.666666666666667%")};
  transition: 0.2s;
`;
